import libphonenumber from "google-libphonenumber";
const invalidErrorObj = { "invalidPhoneNumber": true };
export function phoneNumberValidator(control) {
    const value = control.value;
    if (value === null || value === undefined || value.toString().trim() === "") {
        return null;
    }
    const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    const validString = checkAgainstStrings(value.toString());
    if (value.toString().length > 5 && validString) {
        let stringValue = value.toString().trim();
        try {
            if (stringValue[0] == "0") {
                stringValue = stringValue.replace("0", "+27");
            }
            const number = phoneUtil.parseAndKeepRawInput(stringValue);
            const validNumber = phoneUtil.isValidNumber(number);
            if (validNumber) {
                return null;
            }
            else {
                return invalidErrorObj;
            }
        }
        catch (err) {
            return invalidErrorObj;
        }
    }
    else {
        return invalidErrorObj;
    }
}
function checkAgainstStrings(value) {
    const acceptableCharacters = ["/", "-"];
    let validCharacter = true;
    if (value.length > 5) {
        for (let i = 1; i < value.length; i++) {
            if (isNaN(Number(value[i])) && acceptableCharacters.indexOf(value[i]) < 0) {
                validCharacter = false;
                break;
            }
        }
    }
    return validCharacter;
}
